import {DxAuthenticationStorageStrategy} from "./dx-authentication-storage-strategy";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";

/** Дамми-стратегия. Просто для демонстрирования принципа. **/
@Injectable()
export class DxInMemoryStorageStrategy implements DxAuthenticationStorageStrategy {
  private _session: DxUserSession;

  public store(session: DxUserSession): void {
    this._session = session;
  }

  public extract(): Observable<DxUserSession> {
    return of(this._session);
  }

  public erase(): void {
    this._session = null;
  }
}
